var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSafetyVideoConfirm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "crisis(1) 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M88.9999 69L56.6599 13C55.7822 11.48 54.5198 10.2177 52.9997 9.34011C51.4795 8.46251 49.7552 8.00049 47.9999 8.00049C46.2446 8.00049 44.5203 8.46251 43.0001 9.34011C41.48 10.2177 40.2176 11.48 39.3399 13L6.9999 69C6.12189 70.5208 5.65982 72.246 5.66016 74.002C5.6605 75.758 6.12324 77.483 7.00184 79.0034C7.88044 80.5238 9.14392 81.7861 10.6652 82.6632C12.1865 83.5403 13.9119 84.0014 15.6679 84H80.3319C82.0872 84 83.8117 83.5379 85.3318 82.6602C86.852 81.7825 88.1143 80.5201 88.992 78.9999C89.8696 77.4798 90.3317 75.7553 90.3316 74C90.3316 72.2446 89.8696 70.5202 88.9919 69H88.9999Z",
    fill: "url(#paint0_linear_0_6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M48 60C49.0479 60.0048 50.0598 59.6176 50.8369 58.9145C51.614 58.2114 52.1002 57.2432 52.2 56.2L54.56 32.6C54.6439 31.7648 54.5517 30.9213 54.2893 30.124C54.0268 29.3267 53.6 28.5934 53.0364 27.9713C52.4728 27.3493 51.785 26.8525 51.0173 26.5129C50.2497 26.1733 49.4194 25.9986 48.58 26H47.42C46.5815 26 45.7522 26.1758 44.9858 26.5159C44.2194 26.8561 43.5327 27.3532 42.9702 27.9751C42.4077 28.5969 41.9818 29.3298 41.72 30.1264C41.4581 30.923 41.3661 31.7657 41.45 32.6L43.81 56.2C43.9096 57.2415 44.3944 58.2083 45.1694 58.9111C45.9444 59.614 46.9538 60.0023 48 60Z",
    fill: "url(#paint1_linear_0_6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M48 76C51.866 76 55 72.866 55 69C55 65.134 51.866 62 48 62C44.134 62 41 65.134 41 69C41 72.866 44.134 76 48 76Z",
    fill: "url(#paint2_linear_0_6)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_6",
    x1: 24.2679,
    y1: 40.6721,
    x2: 84.0539,
    y2: 82.7781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59815"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_6",
    x1: 40.636,
    y1: 31.176,
    x2: 55.1,
    y2: 52.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E4154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B2129"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_6",
    x1: 43.558,
    y1: 64.558,
    x2: 52.152,
    y2: 73.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E4154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B2129"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafetyVideoConfirm);
export default __webpack_public_path__ + "static/media/safetyVideoConfirm.422908b800e356b1d8d33df7af520a25.svg";
export { ForwardRef as ReactComponent };